import { ReportsComponent } from './../../components/reports/reports.component';
import { StatefulCSS } from './../../model/stateful_css';
import { DataManagerService } from './../../model/services/data-manager.service';
import { RouteService } from 'app/model/services/route.service';
import { RouteID } from './../../model/services/routes.service';
import { DrawingFeatureType, IFeature } from './../../model/mapping/drawing/Feature';
import { SpatialCoord, PixoPt, PixoSpatial } from './../../model/mapping/Pixospatial';
import { LayerListComponent } from './../../components/layer-list/layer-list.component';
import { RoutesService } from 'app/model/services/routes.service';
import { MapboxBackgroundSet, mapboxBackgrounds, MapBackground, MapMode, MapComponent } from './../../components/map/map.component';
import { EnvService } from 'app/env.service';
import { Component, OnInit, ChangeDetectorRef, ViewChild, TemplateRef, AfterViewInit, ViewEncapsulation, ViewRef, EmbeddedViewRef, Output, Input, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Project } from 'app/model/project';
import { ProjectsService } from 'app/model/services/api-services/projects.service';
import { Point } from 'mapbox-gl';
import { Feature } from 'app/model/mapping/drawing/Feature';
import { IDKeyTypes } from 'app/model/id-manager';
import { TestService } from 'app/model/services/test.service';
import { Route } from 'app/types/route-data';

export type DisplayMode = 'map' | 'report' | 'hybrid';


@Component({
  selector: 'app-project',
  templateUrl: './project.component.html',
  styleUrls: ['./project.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProjectComponent implements OnInit, AfterViewInit {
  private _project_id: number = NaN;
  private _test?: string | null;
  private _ready = false;
  private _workerReady = false;
  private _titleElement?: HTMLDivElement;
  private _project?: Project = new Project();
  private displayModeStates = new StatefulCSS();
  public mapMode: MapMode = 'view';
  public spatialContext?: PixoSpatial;
  public currentRoute?: Route;
  public get project(): Project | undefined {
    return this._project;
  }
  public set project(prj: Project | undefined) {
    this._project = prj;
    this.Refresh();
  }

  private _selected: any = {};
  public set selected(sel: any) {
    this._selected = sel;
    this.Refresh();
  }
  public get selected() {
    return this._selected;
  }
  public mapReady = false;

  public mapBackground?: MapBackground;

  @ViewChild('titleTemplate') titleTemplate?: TemplateRef<ProjectComponent>;
  private _titleView?: any;

  @ViewChild('layerList') layerList!: LayerListComponent;

  @ViewChild('map') map!: MapComponent;
  @ViewChild('mainWorkPane') mainWorkPane!: ElementRef<HTMLDivElement>;
  @ViewChild('reports') reports!: ReportsComponent;
  public get project_id(): number {
    return this._project_id;
  }
  public get projectTitle(): string {
    if (!(!!this._project?.config)) return '';
    const title = this._project.config.general.name;
    return !!title ? title : '';
  }

  public get mapBackgrounds() {
    return mapboxBackgrounds;
  }
  private _displayMode: DisplayMode = 'map';
  @Input()
  public set displayMode(mode: DisplayMode) {
    this._displayMode = mode;
    this.displayModeStates.SetState(mode);
    this.Refresh();
  }
  public get displayMode(): DisplayMode {
    return this._displayMode;
  }
  constructor(
    private projectSvc: ProjectsService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private env: EnvService,
    private routesSvc: RoutesService,
    private testsSvc: TestService,
    private routeSvc: RouteService,
    private dataMgr: DataManagerService) {

  }

  ngOnInit(): void {
    this._ready = true;
    this._project_id = Number(this.route.snapshot.paramMap.get('project_id'));
    this._test = this.route.snapshot.paramMap.get('test');
    this.ClearTitle();
  }
  ngAfterViewInit(): void {
    this._titleElement = this.env.app.GetPageTitle();
    this.displayModeStates.SetPrefix('display');
    this.displayModeStates.AddState('map');
    this.displayModeStates.AddState('report');
    this.displayModeStates.AddState('hybrid');
    this.displayModeStates.SetMachine(this.mainWorkPane.nativeElement);
    this.displayModeStates.SetState('map');
    this.UpdateTitle();
    if (!!this._project_id) {
      this.projectSvc.GetProject(this._project_id).then((response) => {
        this.project = new Project(response.project);
        this.ProjectLoaded();
      });
    }

  }
  ProjectLoaded() {
    if (!this.project) return;
    if (!this.map.drawPane) return;
    if (!this.mapReady) {
      window.requestAnimationFrame(() => {
        this.ProjectLoaded();
      });
      return;
    }
    this.UpdateTitle();
    this.dataMgr.SetProject(this.project);
    this.project.SetUI(this.map.drawPane);
    this.routesSvc.SetContext(this.project);
    this.map.drawPane?.hasVerticesChange.subscribe((value) => {
      this.reports.RefreshAll();
    })
    this.SelectBackground(this.mapBackgrounds[this.mapBackgrounds.length - 1])
    window.requestAnimationFrame(() => {
      this.SetupTest();
    })
  }
  SetupTest() {
    if (!this._test) return;
    const test = this.testsSvc.MakeTest(this._test, Number(this.map.ui.getContainer().clientWidth / 2.0), Number(this.map.ui.getContainer().clientHeight / 2.0));
    if (!test) return;
    let a1 = this.routesSvc.AddRoute({
      data: {},
      name: 'A1'
    });
    // this.map.drawPane.AddRouteLayer(a1);
    let b1 = this.routesSvc.AddRoute({
      data: {},
      name: 'B1'
    })
    //this.map.drawPane.AddRouteLayer(b1);

    let c1 = this.routesSvc.AddRoute({
      data: {},
      name: 'C1'
    }, b1.id);

    let b2 = this.routesSvc.AddRoute({
      data: {},
      name: 'B2'
    }, a1.id)

    // this.map.drawPane.AddRouteLayer(c1);
    let c2 = this.routesSvc.AddRoute({
      data: {},
      name: 'C2'
    }, b2.id);
    // this.map.drawPane.AddRouteLayer(c2);
    let d1 = this.routesSvc.AddRoute({
      data: {},
      name: 'D1'
    }, c2.id);
    //this.map.drawPane.AddRouteLayer(d1);

    let e1 = this.routesSvc.AddRoute({
      data: {},
      name: 'E1'
    }, a1.id);
    //this.map.drawPane.AddRouteLayer(e1);

    let f1 = this.routesSvc.AddRoute({
      data: {},
      name: 'F1'
    }, e1.id);
    //this.map.drawPane.AddRouteLayer(f1);

    let g1 = this.routesSvc.AddRoute({
      data: {},
      name: 'G1'
    }, a1.id);
    this.layerList.UpdateTree(true);

    //this.map.drawPane.AddRouteLayer(g1);

    const me = this;
    setTimeout(() => {
      this.mapMode = 'edit';
      for (const routeName in test.data) {
        let id;
        switch (routeName) {
          case 'A1':
            id = a1.id;
            break;
          case 'B1':
            id = b1.id;
            break;
          case 'B1.C1':
            id = c1.id;
            break;
          case 'A1.B2':
            id = b2.id;
            break;
          case 'A1.B2.C2':
            id = c2.id;
            break;
          case 'A1.B2.C2.D1':
            id = d1.id;
            break;
          case 'A1.E1':
            id = e1.id;
            break;
          case 'A1.G1':
            id = g1.id;
        }
        if (!id) continue;
        this.layerList.SelectById(id);

        for (const ptInfo of test.data[routeName]) {
          me.map?.drawPane?.AddVertex(ptInfo[0], ptInfo[1]);
        }
      }
      this.layerList.SelectById(0);

    }, 1000);

  }
  UpdateTitle() {
    if (!this._titleView) {
      this.ClearTitle();
      this._titleView = this.titleTemplate?.createEmbeddedView(this);
    }

    this._titleView?.detectChanges();
    if (!this._titleView) return;
    for (const node of this._titleView.rootNodes) {
      this._titleElement?.append(node);
    }
  }
  ClearTitle() {
    if (!this._titleElement) return;
    this._titleElement.innerHTML = '';
  }
  SetTitle() {

  }
  SelectBackground(bg: MapBackground) {
    this.mapBackground = bg;
    this.Refresh();

  }
  SetMapMode(mode: MapMode) {
    this.mapMode = mode;
    if(!!this.project) this.project.viewMode = mode;
    this.Refresh();
  }
  SetDisplayMode(mode: DisplayMode) {
    this.displayMode = mode;
    this.map.Resize();
  }
  SelectRoute(routeID: RouteID) {
    this.currentRoute = this.project?.idRegistry.Get(routeID) as Route;
    this.map.drawPane?.SetMapLayer(routeID);
    this.Refresh();
  }

  Refresh() {
    if (this._ready) {
      this.cdr.detectChanges();
      this.UpdateTitle();
    }
  }
  RemoveRouteLayer(routeID: RouteID) {
    //this.map.drawPane!.RemoveRouteLayer(routeID);
    this.Refresh();
  }
  HandleMap() {
    if (!this.map.drawPane) {
      window.requestAnimationFrame(() => {
        this.HandleMap();
      });
      return;
    }
    this.spatialContext = new PixoSpatial();
    this.map.drawPane.SetSpatialContext(this.spatialContext);

    // this.tooltip.SetMap(this.spatialContext, mapUI);

    this.spatialContext.Attach(
      (spatialCoord: SpatialCoord): PixoPt => {
        const pt: mapboxgl.Point = this.map.ui.project(spatialCoord);
        return this.spatialContext!.PixoPt(pt);
      },
      (pixoPt: PixoPt) => {
        const pt: Point = new Point(pixoPt.x, pixoPt.y);
        // const startPosition: MapPosition = this.map.viewPosition;
        /*this.map.SetViewPosition({
          location: {
            center: this.map.GetCenter(),
            zoom: startPosition.location.zoom,
            bearing: 0,
            pitch: 0,
          },
          width: startPosition.width,
          height: startPosition.height


        }, NavEvents.NewInternal('viewstate/set-un-oriented'));
        */
        this.map.ui.setBearing(0, { internal: true });
        this.map.ui.setPitch(0, { internal: true });
        const lngLat: mapboxgl.LngLat = this.map.ui.unproject(pt);
        //this.map.SetViewPosition(startPosition, NavEvents.NewInternal('viewstate/set-oriented'));
        return this.spatialContext!.SpatialCoord(lngLat);

      }
    );
    this.mapReady = true;
  }
  ShowReports() {
    if(this.displayMode === 'map') {
      this.SetDisplayMode('hybrid');
    }
  }
}
